import { render, staticRenderFns } from "./SweetAlertAnimation.vue?vue&type=template&id=0064b785&"
import script from "./SweetAlertAnimation.vue?vue&type=script&lang=js&"
export * from "./SweetAlertAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports